<template>
  <v-container class="pa-4 ma-0 full-height">

    <div class="font-weight-bold" style="font-size: 20px;">{{ utente }}</div>

    <div class="menu-container" v-for="(item, i) in menuTestata" :key="i">
      <div @click="goto(item)" class="menu-item">
        {{ item.descrizione }}
        <v-icon class="icon-right">chevron_right</v-icon>
      </div>
    </div>

  </v-container>
</template>

<script>


export default {
  data() {
    return {
      attesa: false
    };
  },
  methods: {
    goto(item) {
      let dett = this.getMenuDettaglio(item.menuId);
      if (!!dett == false) return;

      this.$store.dispatch("app/goto", { link: dett.programPath, tipo: dett.method });
    },

    getMenuDettaglio(menuId) {
      let dett = this.menu.menuDettaglio.find((f) =>
        f.menuIdList.includes("-" + menuId + "-")
      );
      return dett;
    },


  },

  mounted() {

  },

  computed: {

    utente() {
      return this.$store.getters["user/getDescUser"];
    },

    menu() {
      return this.$store.getters["user/getMenu"];
    },
    menuTestata() {
      return this.menu.menuTestata;
    },
  }
};
</script>

<style lang="stylus" scoped>
.menu-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1 1 auto;
}

.menu-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  color: black;
  padding: 12px 2px;
  width: 100%;
  font-size: 1.2em;
  text-decoration: none;
  display: flex;
  position: relative;
  color: #1976d2;
  cursor: pointer;
}

.icon-right {
  position: absolute;
  right: 0;
}
</style>

